/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { LoginCredential } from './models';
import { LoginCredentialHashed } from './models';
import { HostProtocol } from '@iotize/tap';
import { SecurityOptions } from './models';
import { NfcPairingMode } from './models';
import { WirelessPairingOptions } from './models';
import { LowPowerOptimizationLevel } from './models';
import { CpuFrequencyOptions } from './models';
import { CpuFrequencySpeed } from '@iotize/tap';
import { PowerOptimizationOptions } from './models';
import { ServiceCode } from './models';
import { NetworkOptions } from './models';
import { NfcConnectionPriority } from './models';
import { ProtocolMaxFrameSize } from './models';
import { MultiRequestFrame } from './models';
import { MultiResponseFrame } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';

export class InterfaceService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Login
   *
   * LWM2M path: /1024//0
   *
   * @tapVersion(">=1.0")
   * @param credential input
   * @return
   */
  login(
    /*
     * Username/password credentials
     */
    credential: LoginCredential,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.loginCall(credential));
  }

  /**
   *
   *
   * LWM2M path: /1024//0
   *
   * @tapVersion(">=1.0")
   * @param credential input
   * @return call options
   */
  loginCall(
    /*
     * Username/password credentials
     */
    credential: LoginCredential,
  ): ServiceCallType {
    const callOptions = { ...this.resources.login };

    callOptions.body = credential;

    return callOptions;
  }

  /**
   * Login
   *
   * LWM2M path: /1024//0
   *
   * @tapVersion(">=1.0")
   * @param credential input
   * @return
   */
  loginWithHash(
    /*
     *
     */
    credential: LoginCredentialHashed,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.loginWithHashCall(credential));
  }

  /**
   *
   *
   * LWM2M path: /1024//0
   *
   * @tapVersion(">=1.0")
   * @param credential input
   * @return call options
   */
  loginWithHashCall(
    /*
     *
     */
    credential: LoginCredentialHashed,
  ): ServiceCallType {
    const callOptions = { ...this.resources.loginWithHash };

    callOptions.body = credential;

    return callOptions;
  }

  /**
   * Logout
   *
   * LWM2M path: /1024//1
   *
   * @tapVersion(">=1.0")
   * @return
   */
  logout(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.logoutCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//1
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  logoutCall(): ServiceCallType {
    const callOptions = { ...this.resources.logout };

    return callOptions;
  }

  /**
   * Get current profile id
   *
   * LWM2M path: /1024//2
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getCurrentProfileId(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getCurrentProfileIdCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//2
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getCurrentProfileIdCall(): ServiceCallType {
    const callOptions = { ...this.resources.getCurrentProfileId };

    return callOptions;
  }

  /**
   * Get current host protocol
   *
   * LWM2M path: /1024//3
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getCurrentHostProtocol(): Promise<TapResponse<HostProtocol>> {
    return this.serviceCallRunner.execute(this.getCurrentHostProtocolCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//3
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getCurrentHostProtocolCall(): ServiceCallType {
    const callOptions = { ...this.resources.getCurrentHostProtocol };

    return callOptions;
  }

  /**
   * Write current host protocol
   *
   * LWM2M path: /1024//3
   *
   * @tapVersion(">=1.0")
   * @param hostProtocol input
   * @return
   */
  putCurrentHostProtocol(
    /*
     *
     */
    hostProtocol: HostProtocol,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putCurrentHostProtocolCall(hostProtocol),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//3
   *
   * @tapVersion(">=1.0")
   * @param hostProtocol input
   * @return call options
   */
  putCurrentHostProtocolCall(
    /*
     *
     */
    hostProtocol: HostProtocol,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putCurrentHostProtocol };

    callOptions.body = hostProtocol;

    return callOptions;
  }

  /**
   * Get PUK UID value
   *
   * LWM2M path: /1024//5
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getUID(): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(this.getUIDCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//5
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getUIDCall(): ServiceCallType {
    const callOptions = { ...this.resources.getUID };

    return callOptions;
  }

  /**
   * Administrator login with UID.
   *
   * LWM2M path: /1024//5
   *
   * @tapVersion(">=1.0")
   * @param uid input
   * @return
   */
  loginWithUID(
    /*
     *
     */
    uid: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.loginWithUIDCall(uid));
  }

  /**
   *
   *
   * LWM2M path: /1024//5
   *
   * @tapVersion(">=1.0")
   * @param uid input
   * @return call options
   */
  loginWithUIDCall(
    /*
     *
     */
    uid: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.loginWithUID };

    callOptions.body = uid;

    return callOptions;
  }

  /**
   * Keep alive.
   *
   * LWM2M path: /1024//4
   *
   * @tapVersion(">=1.0")
   * @return
   */
  keepAlive(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.keepAliveCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//4
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  keepAliveCall(): ServiceCallType {
    const callOptions = { ...this.resources.keepAlive };

    return callOptions;
  }

  /**
   * Keep alive.
   *
   * LWM2M path: /1024//4
   *
   * @tapVersion(">=1.0")
   * @return
   */
  postKeepAlive(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.postKeepAliveCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//4
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  postKeepAliveCall(): ServiceCallType {
    const callOptions = { ...this.resources.postKeepAlive };

    return callOptions;
  }

  /**
   * Get lock infos
   *
   * LWM2M path: /1024//6
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getSecurityOptions(): Promise<TapResponse<SecurityOptions>> {
    return this.serviceCallRunner.execute(this.getSecurityOptionsCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//6
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getSecurityOptionsCall(): ServiceCallType {
    const callOptions = { ...this.resources.getSecurityOptions };

    return callOptions;
  }

  /**
   * Put lock infos
   *
   * LWM2M path: /1024//6
   *
   * @tapVersion(">=1.0")
   * @param infos input
   * @return
   */
  putSecurityOptions(
    /*
     * lock informations
     */
    infos: SecurityOptions,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putSecurityOptionsCall(infos));
  }

  /**
   *
   *
   * LWM2M path: /1024//6
   *
   * @tapVersion(">=1.0")
   * @param infos input
   * @return call options
   */
  putSecurityOptionsCall(
    /*
     * lock informations
     */
    infos: SecurityOptions,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putSecurityOptions };

    callOptions.body = infos;

    return callOptions;
  }

  /**
   * Get current group id
   *
   * LWM2M path: /1024//7
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getCurrentGroupId(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getCurrentGroupIdCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//7
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getCurrentGroupIdCall(): ServiceCallType {
    const callOptions = { ...this.resources.getCurrentGroupId };

    return callOptions;
  }

  /**
   * Get bundle Id for SWD Direct
   *
   * LWM2M path: /1024//100
   *
   * @tapVersion(">=1.23")
   * @return
   */
  getBundleIdSwdDirectAccess(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(
      this.getBundleIdSwdDirectAccessCall(),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//100
   *
   * @tapVersion(">=1.23")
   * @return call options
   */
  getBundleIdSwdDirectAccessCall(): ServiceCallType {
    const callOptions = { ...this.resources.getBundleIdSwdDirectAccess };

    return callOptions;
  }

  /**
   * Set bundle Id for SWD Direct
   *
   * LWM2M path: /1024//100
   *
   * @tapVersion(">=1.23")
   * @param bundleId input
   * @return
   */
  putBundleIdSwdDirectAccess(
    /*
     *
     */
    bundleId: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putBundleIdSwdDirectAccessCall(bundleId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//100
   *
   * @tapVersion(">=1.23")
   * @param bundleId input
   * @return call options
   */
  putBundleIdSwdDirectAccessCall(
    /*
     *
     */
    bundleId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putBundleIdSwdDirectAccess };

    callOptions.body = bundleId;

    return callOptions;
  }

  /**
   * Get bundle Id for Serial Direct
   *
   * LWM2M path: /1024//101
   *
   * @tapVersion(">=1.23")
   * @return
   */
  getBundleIdSerialAccess(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getBundleIdSerialAccessCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//101
   *
   * @tapVersion(">=1.23")
   * @return call options
   */
  getBundleIdSerialAccessCall(): ServiceCallType {
    const callOptions = { ...this.resources.getBundleIdSerialAccess };

    return callOptions;
  }

  /**
   * Set bundle Id for Serial Direct
   *
   * LWM2M path: /1024//101
   *
   * @tapVersion(">=1.23")
   * @param bundleId input
   * @return
   */
  putBundleIdSerialAccess(
    /*
     *
     */
    bundleId: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putBundleIdSerialAccessCall(bundleId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//101
   *
   * @tapVersion(">=1.23")
   * @param bundleId input
   * @return call options
   */
  putBundleIdSerialAccessCall(
    /*
     *
     */
    bundleId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putBundleIdSerialAccess };

    callOptions.body = bundleId;

    return callOptions;
  }

  /**
   * Get bundle Id for Modbus Direct
   *
   * LWM2M path: /1024//102
   *
   * @tapVersion(">=1.23")
   * @return
   */
  getBundleIdModbusDirectAccess(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(
      this.getBundleIdModbusDirectAccessCall(),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//102
   *
   * @tapVersion(">=1.23")
   * @return call options
   */
  getBundleIdModbusDirectAccessCall(): ServiceCallType {
    const callOptions = { ...this.resources.getBundleIdModbusDirectAccess };

    return callOptions;
  }

  /**
   * Set bundle Id for Modbus Direct
   *
   * LWM2M path: /1024//102
   *
   * @tapVersion(">=1.23")
   * @param bundleId input
   * @return
   */
  putBundleIdModbusDirectAccess(
    /*
     *
     */
    bundleId: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putBundleIdModbusDirectAccessCall(bundleId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//102
   *
   * @tapVersion(">=1.23")
   * @param bundleId input
   * @return call options
   */
  putBundleIdModbusDirectAccessCall(
    /*
     *
     */
    bundleId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putBundleIdModbusDirectAccess };

    callOptions.body = bundleId;

    return callOptions;
  }

  /**
   * Get bundle Id for TapNPass Control
   *
   * LWM2M path: /1024//103
   *
   * @tapVersion(">=1.23")
   * @return
   */
  getBundleIdTapnpassControlAccess(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(
      this.getBundleIdTapnpassControlAccessCall(),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//103
   *
   * @tapVersion(">=1.23")
   * @return call options
   */
  getBundleIdTapnpassControlAccessCall(): ServiceCallType {
    const callOptions = { ...this.resources.getBundleIdTapnpassControlAccess };

    return callOptions;
  }

  /**
   * Set bundle Id for TapNPass Control
   *
   * LWM2M path: /1024//103
   *
   * @tapVersion(">=1.23")
   * @param bundleId input
   * @return
   */
  putBundleIdTapnpassControlAccess(
    /*
     *
     */
    bundleId: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putBundleIdTapnpassControlAccessCall(bundleId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//103
   *
   * @tapVersion(">=1.23")
   * @param bundleId input
   * @return call options
   */
  putBundleIdTapnpassControlAccessCall(
    /*
     *
     */
    bundleId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putBundleIdTapnpassControlAccess };

    callOptions.body = bundleId;

    return callOptions;
  }

  /**
   * Get bundle Id for Firmware Update
   *
   * LWM2M path: /1024//104
   *
   * @tapVersion(">=1.35")
   * @return
   */
  getBundleIdFirmwareUpdateAccess(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(
      this.getBundleIdFirmwareUpdateAccessCall(),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//104
   *
   * @tapVersion(">=1.35")
   * @return call options
   */
  getBundleIdFirmwareUpdateAccessCall(): ServiceCallType {
    const callOptions = { ...this.resources.getBundleIdFirmwareUpdateAccess };

    return callOptions;
  }

  /**
   * Set bundle Id for Firmware Update
   *
   * LWM2M path: /1024//104
   *
   * @tapVersion(">=1.35")
   * @param bundleId input
   * @return
   */
  putBundleIdFirmwareUpdateAccess(
    /*
     *
     */
    bundleId: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putBundleIdFirmwareUpdateAccessCall(bundleId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//104
   *
   * @tapVersion(">=1.35")
   * @param bundleId input
   * @return call options
   */
  putBundleIdFirmwareUpdateAccessCall(
    /*
     *
     */
    bundleId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putBundleIdFirmwareUpdateAccess };

    callOptions.body = bundleId;

    return callOptions;
  }

  /**
   * Get bundle Id for MQTT IDs
   *
   * LWM2M path: /1024//105
   *
   * @tapVersion(">=1.35")
   * @return
   */
  getBundleIdMqttIdsAccess(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getBundleIdMqttIdsAccessCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//105
   *
   * @tapVersion(">=1.35")
   * @return call options
   */
  getBundleIdMqttIdsAccessCall(): ServiceCallType {
    const callOptions = { ...this.resources.getBundleIdMqttIdsAccess };

    return callOptions;
  }

  /**
   * Set bundle Id for MQTT IDs
   *
   * LWM2M path: /1024//105
   *
   * @tapVersion(">=1.35")
   * @param bundleId input
   * @return
   */
  putBundleIdMqttIdsAccess(
    /*
     *
     */
    bundleId: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putBundleIdMqttIdsAccessCall(bundleId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//105
   *
   * @tapVersion(">=1.35")
   * @param bundleId input
   * @return call options
   */
  putBundleIdMqttIdsAccessCall(
    /*
     *
     */
    bundleId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putBundleIdMqttIdsAccess };

    callOptions.body = bundleId;

    return callOptions;
  }

  /**
   * Get bundle Id for Variable Config
   *
   * LWM2M path: /1024//106
   *
   * @tapVersion(">=2.11")
   * @return
   */
  getBundleIdVariableConfigAccess(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(
      this.getBundleIdVariableConfigAccessCall(),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//106
   *
   * @tapVersion(">=2.11")
   * @return call options
   */
  getBundleIdVariableConfigAccessCall(): ServiceCallType {
    const callOptions = { ...this.resources.getBundleIdVariableConfigAccess };

    return callOptions;
  }

  /**
   * Set bundle Id for Variable Config
   *
   * LWM2M path: /1024//106
   *
   * @tapVersion(">=2.11")
   * @param bundleId input
   * @return
   */
  putBundleIdVariableConfigAccess(
    /*
     *
     */
    bundleId: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putBundleIdVariableConfigAccessCall(bundleId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//106
   *
   * @tapVersion(">=2.11")
   * @param bundleId input
   * @return call options
   */
  putBundleIdVariableConfigAccessCall(
    /*
     *
     */
    bundleId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putBundleIdVariableConfigAccess };

    callOptions.body = bundleId;

    return callOptions;
  }

  /**
   * Get bundle Id for File System
   *
   * LWM2M path: /1024//107
   *
   * @tapVersion(">=2.13")
   * @return
   */
  getBundleIdFileSystemAccess(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(
      this.getBundleIdFileSystemAccessCall(),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//107
   *
   * @tapVersion(">=2.13")
   * @return call options
   */
  getBundleIdFileSystemAccessCall(): ServiceCallType {
    const callOptions = { ...this.resources.getBundleIdFileSystemAccess };

    return callOptions;
  }

  /**
   * Set bundle Id for File System
   *
   * LWM2M path: /1024//107
   *
   * @tapVersion(">=2.13")
   * @param bundleId input
   * @return
   */
  putBundleIdFileSystemAccess(
    /*
     *
     */
    bundleId: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putBundleIdFileSystemAccessCall(bundleId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//107
   *
   * @tapVersion(">=2.13")
   * @param bundleId input
   * @return call options
   */
  putBundleIdFileSystemAccessCall(
    /*
     *
     */
    bundleId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putBundleIdFileSystemAccess };

    callOptions.body = bundleId;

    return callOptions;
  }

  /**
   * Get config format version
   *
   * LWM2M path: /1024//8
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getConfigFormatVersion(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getConfigFormatVersionCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//8
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getConfigFormatVersionCall(): ServiceCallType {
    const callOptions = { ...this.resources.getConfigFormatVersion };

    return callOptions;
  }

  /**
   * Set config format version
   *
   * LWM2M path: /1024//8
   *
   * @tapVersion(">=1.0")
   * @param configFormat input
   * @return
   */
  putConfigFormatVersion(
    /*
     *
     */
    configFormat: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putConfigFormatVersionCall(configFormat),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//8
   *
   * @tapVersion(">=1.0")
   * @param configFormat input
   * @return call options
   */
  putConfigFormatVersionCall(
    /*
     *
     */
    configFormat: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putConfigFormatVersion };

    callOptions.body = configFormat;

    return callOptions;
  }

  /**
   * Get application name
   *
   * LWM2M path: /1024//9
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getAppName(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getAppNameCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//9
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getAppNameCall(): ServiceCallType {
    const callOptions = { ...this.resources.getAppName };

    return callOptions;
  }

  /**
   * Set application name
   *
   * LWM2M path: /1024//9
   *
   * @tapVersion(">=1.0")
   * @param appName input
   * @return
   */
  putAppName(
    /*
     *
     */
    appName: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putAppNameCall(appName));
  }

  /**
   *
   *
   * LWM2M path: /1024//9
   *
   * @tapVersion(">=1.0")
   * @param appName input
   * @return call options
   */
  putAppNameCall(
    /*
     *
     */
    appName: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putAppName };

    callOptions.body = appName;

    return callOptions;
  }

  /**
   * Get config version
   *
   * LWM2M path: /1024//10
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getConfigVersion(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getConfigVersionCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//10
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getConfigVersionCall(): ServiceCallType {
    const callOptions = { ...this.resources.getConfigVersion };

    return callOptions;
  }

  /**
   * Set config version
   *
   * LWM2M path: /1024//10
   *
   * @tapVersion(">=1.0")
   * @param version input
   * @return
   */
  putConfigVersion(
    /*
     *
     */
    version: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putConfigVersionCall(version));
  }

  /**
   *
   *
   * LWM2M path: /1024//10
   *
   * @tapVersion(">=1.0")
   * @param version input
   * @return call options
   */
  putConfigVersionCall(
    /*
     *
     */
    version: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putConfigVersion };

    callOptions.body = version;

    return callOptions;
  }

  /**
   * Apply the new configuration on the Tap
   *
   * LWM2M path: /1024//10
   *
   * @tapVersion(">=1.0")
   * @return
   */
  reloadConfig(): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.reloadConfigCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//10
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  reloadConfigCall(): ServiceCallType {
    const callOptions = { ...this.resources.reloadConfig };

    return callOptions;
  }

  /**
   * Get app path
   *
   * LWM2M path: /1024//11
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getAppPath(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getAppPathCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//11
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getAppPathCall(): ServiceCallType {
    const callOptions = { ...this.resources.getAppPath };

    return callOptions;
  }

  /**
   * Set app path
   *
   * LWM2M path: /1024//11
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return
   */
  putAppPath(
    /*
     *
     */
    value: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putAppPathCall(value));
  }

  /**
   *
   *
   * LWM2M path: /1024//11
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return call options
   */
  putAppPathCall(
    /*
     *
     */
    value: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putAppPath };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Set app path
   *
   * LWM2M path: /1024//11
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return
   */
  postAppPath(
    /*
     *
     */
    value: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.postAppPathCall(value));
  }

  /**
   *
   *
   * LWM2M path: /1024//11
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return call options
   */
  postAppPathCall(
    /*
     *
     */
    value: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.postAppPath };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Check if nfc paring is mandatory
   *
   * LWM2M path: /1024//13
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getNfcPairingMode(): Promise<TapResponse<NfcPairingMode>> {
    return this.serviceCallRunner.execute(this.getNfcPairingModeCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//13
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getNfcPairingModeCall(): ServiceCallType {
    const callOptions = { ...this.resources.getNfcPairingMode };

    return callOptions;
  }

  /**
   * Change wether nfc pairing is mandatory.
   *
   * LWM2M path: /1024//13
   *
   * @tapVersion(">=1.0")
   * @param mode input
   * @return
   */
  putNfcPairingMode(
    /*
     *
     */
    mode: NfcPairingMode,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putNfcPairingModeCall(mode));
  }

  /**
   *
   *
   * LWM2M path: /1024//13
   *
   * @tapVersion(">=1.0")
   * @param mode input
   * @return call options
   */
  putNfcPairingModeCall(
    /*
     *
     */
    mode: NfcPairingMode,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putNfcPairingMode };

    callOptions.body = mode;

    return callOptions;
  }

  /**
   * Get pairing options
   *
   * LWM2M path: /1024//13
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getPairingOptions(): Promise<TapResponse<WirelessPairingOptions>> {
    return this.serviceCallRunner.execute(this.getPairingOptionsCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//13
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getPairingOptionsCall(): ServiceCallType {
    const callOptions = { ...this.resources.getPairingOptions };

    return callOptions;
  }

  /**
   * Set pairing options (temporary)
   *
   * LWM2M path: /1024//13
   *
   * @tapVersion(">=1.0")
   * @param options input
   * @return
   */
  postPairingOptions(
    /*
     *
     */
    options: WirelessPairingOptions,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.postPairingOptionsCall(options));
  }

  /**
   *
   *
   * LWM2M path: /1024//13
   *
   * @tapVersion(">=1.0")
   * @param options input
   * @return call options
   */
  postPairingOptionsCall(
    /*
     *
     */
    options: WirelessPairingOptions,
  ): ServiceCallType {
    const callOptions = { ...this.resources.postPairingOptions };

    callOptions.body = options;

    return callOptions;
  }

  /**
   * Write pairing options
   *
   * LWM2M path: /1024//13
   *
   * @tapVersion(">=1.0")
   * @param options input
   * @return
   */
  putPairingOptions(
    /*
     *
     */
    options: WirelessPairingOptions,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putPairingOptionsCall(options));
  }

  /**
   *
   *
   * LWM2M path: /1024//13
   *
   * @tapVersion(">=1.0")
   * @param options input
   * @return call options
   */
  putPairingOptionsCall(
    /*
     *
     */
    options: WirelessPairingOptions,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putPairingOptions };

    callOptions.body = options;

    return callOptions;
  }

  /**
   * Get power optimization level
   *
   * LWM2M path: /1024//14
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getPowerOptimisationLevel(): Promise<TapResponse<LowPowerOptimizationLevel>> {
    return this.serviceCallRunner.execute(this.getPowerOptimisationLevelCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//14
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getPowerOptimisationLevelCall(): ServiceCallType {
    const callOptions = { ...this.resources.getPowerOptimisationLevel };

    return callOptions;
  }

  /**
   * Write power optimization level
   *
   * LWM2M path: /1024//14
   *
   * @tapVersion(">=1.0")
   * @param mode input
   * @return
   */
  putPowerOptimisationLevel(
    /*
     *
     */
    mode: LowPowerOptimizationLevel,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putPowerOptimisationLevelCall(mode),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//14
   *
   * @tapVersion(">=1.0")
   * @param mode input
   * @return call options
   */
  putPowerOptimisationLevelCall(
    /*
     *
     */
    mode: LowPowerOptimizationLevel,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putPowerOptimisationLevel };

    callOptions.body = mode;

    return callOptions;
  }

  /**
   * Get Tap CPU frequency options
   *
   * LWM2M path: /1024//141
   *
   * @tapVersion(">=2.15")
   * @return
   */
  getCpuFrequencyOptions(): Promise<TapResponse<CpuFrequencyOptions>> {
    return this.serviceCallRunner.execute(this.getCpuFrequencyOptionsCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//141
   *
   * @tapVersion(">=2.15")
   * @return call options
   */
  getCpuFrequencyOptionsCall(): ServiceCallType {
    const callOptions = { ...this.resources.getCpuFrequencyOptions };

    return callOptions;
  }

  /**
   * Write Tap CPU frequency setting
   *
   * LWM2M path: /1024//141
   *
   * @tapVersion(">=2.15")
   * @param mode input
   * @return
   */
  putCpuFrequencyOptions(
    /*
     *
     */
    mode: CpuFrequencySpeed,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putCpuFrequencyOptionsCall(mode),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//141
   *
   * @tapVersion(">=2.15")
   * @param mode input
   * @return call options
   */
  putCpuFrequencyOptionsCall(
    /*
     *
     */
    mode: CpuFrequencySpeed,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putCpuFrequencyOptions };

    callOptions.body = mode;

    return callOptions;
  }

  /**
   * Get power optimization options
   *
   * LWM2M path: /1024//142
   *
   * @tapVersion(">=2.15")
   * @return
   */
  getPowerOptimisationOptions(): Promise<
    TapResponse<PowerOptimizationOptions>
  > {
    return this.serviceCallRunner.execute(
      this.getPowerOptimisationOptionsCall(),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//142
   *
   * @tapVersion(">=2.15")
   * @return call options
   */
  getPowerOptimisationOptionsCall(): ServiceCallType {
    const callOptions = { ...this.resources.getPowerOptimisationOptions };

    return callOptions;
  }

  /**
   * Write power optimization options
   *
   * LWM2M path: /1024//142
   *
   * @tapVersion(">=2.15")
   * @param mode input
   * @return
   */
  putPowerOptimisationOptions(
    /*
     *
     */
    mode: PowerOptimizationOptions,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putPowerOptimisationOptionsCall(mode),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//142
   *
   * @tapVersion(">=2.15")
   * @param mode input
   * @return call options
   */
  putPowerOptimisationOptionsCall(
    /*
     *
     */
    mode: PowerOptimizationOptions,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putPowerOptimisationOptions };

    callOptions.body = mode;

    return callOptions;
  }

  /**
   * Get Maximum duration of the low power state
   *
   * LWM2M path: /1024//33
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getMaxLowPowerTime(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getMaxLowPowerTimeCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//33
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getMaxLowPowerTimeCall(): ServiceCallType {
    const callOptions = { ...this.resources.getMaxLowPowerTime };

    return callOptions;
  }

  /**
   * Set Maximum duration of the low power state
   *
   * LWM2M path: /1024//33
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putMaxLowPowerTime(
    /*
     *
     */
    key: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putMaxLowPowerTimeCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//33
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putMaxLowPowerTimeCall(
    /*
     *
     */
    key: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putMaxLowPowerTime };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Read auto reboot timeout value
   *
   * LWM2M path: /1024//123
   *
   * @tapVersion(">=2.11")
   * @return
   */
  getAutoRebootTimeout(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getAutoRebootTimeoutCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//123
   *
   * @tapVersion(">=2.11")
   * @return call options
   */
  getAutoRebootTimeoutCall(): ServiceCallType {
    const callOptions = { ...this.resources.getAutoRebootTimeout };

    return callOptions;
  }

  /**
   * Write auto reboot timeout value
   *
   * LWM2M path: /1024//123
   *
   * @tapVersion(">=2.11")
   * @param bundleId input
   * @return
   */
  putAutoRebootTimeout(
    /*
     *
     */
    bundleId: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putAutoRebootTimeoutCall(bundleId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//123
   *
   * @tapVersion(">=2.11")
   * @param bundleId input
   * @return call options
   */
  putAutoRebootTimeoutCall(
    /*
     *
     */
    bundleId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putAutoRebootTimeout };

    callOptions.body = bundleId;

    return callOptions;
  }

  /**
   * Get authorized host protocols
   *
   * LWM2M path: /1024//17
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getAuthorizedHostProtocol(): Promise<TapResponse<HostProtocol[]>> {
    return this.serviceCallRunner.execute(this.getAuthorizedHostProtocolCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//17
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getAuthorizedHostProtocolCall(): ServiceCallType {
    const callOptions = { ...this.resources.getAuthorizedHostProtocol };

    return callOptions;
  }

  /**
   * Write authorized host protocols
   *
   * LWM2M path: /1024//17
   *
   * @tapVersion(">=1.0")
   * @param mode input
   * @return
   */
  putAuthorizedHostProtocol(
    /*
     *
     */
    mode: HostProtocol[],
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putAuthorizedHostProtocolCall(mode),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//17
   *
   * @tapVersion(">=1.0")
   * @param mode input
   * @return call options
   */
  putAuthorizedHostProtocolCall(
    /*
     *
     */
    mode: HostProtocol[],
  ): ServiceCallType {
    const callOptions = { ...this.resources.putAuthorizedHostProtocol };

    callOptions.body = mode;

    return callOptions;
  }

  /**
   * Get config format firmware version
   *
   * LWM2M path: /1024//18
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getConfigFormatFirmwareVersion(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(
      this.getConfigFormatFirmwareVersionCall(),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//18
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getConfigFormatFirmwareVersionCall(): ServiceCallType {
    const callOptions = { ...this.resources.getConfigFormatFirmwareVersion };

    return callOptions;
  }

  /**
   * Get configured universal link value
   *
   * LWM2M path: /1024//19
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getUniversalLink(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getUniversalLinkCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//19
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getUniversalLinkCall(): ServiceCallType {
    const callOptions = { ...this.resources.getUniversalLink };

    return callOptions;
  }

  /**
   * Write universal link value
   *
   * LWM2M path: /1024//19
   *
   * @tapVersion(">=1.0")
   * @param url input
   * @return
   */
  putUniversalLink(
    /*
     *
     */
    url: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putUniversalLinkCall(url));
  }

  /**
   *
   *
   * LWM2M path: /1024//19
   *
   * @tapVersion(">=1.0")
   * @param url input
   * @return call options
   */
  putUniversalLinkCall(
    /*
     *
     */
    url: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putUniversalLink };

    callOptions.body = url;

    return callOptions;
  }

  /**
   * Set universal link value
   *
   * LWM2M path: /1024//19
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return
   */
  postUniversalLink(
    /*
     *
     */
    value: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.postUniversalLinkCall(value));
  }

  /**
   *
   *
   * LWM2M path: /1024//19
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return call options
   */
  postUniversalLinkCall(
    /*
     *
     */
    value: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.postUniversalLink };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * List instances of another object
   *
   * LWM2M path: /1024//140
   *
   * @tapVersion(">=2.13")
   * @param objectId input
   * @return
   */
  listObjectInstances(
    /*
     *
     */
    objectId: number,
  ): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(
      this.listObjectInstancesCall(objectId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//140
   *
   * @tapVersion(">=2.13")
   * @param objectId input
   * @return call options
   */
  listObjectInstancesCall(
    /*
     *
     */
    objectId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.listObjectInstances };

    callOptions.body = objectId;

    return callOptions;
  }

  /**
   * Get available host protocols
   *
   * LWM2M path: /1024//21
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getAvailableHostProtocols(): Promise<TapResponse<HostProtocol[]>> {
    return this.serviceCallRunner.execute(this.getAvailableHostProtocolsCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//21
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getAvailableHostProtocolsCall(): ServiceCallType {
    const callOptions = { ...this.resources.getAvailableHostProtocols };

    return callOptions;
  }

  /**
   * Get currently disabled service list
   *
   * LWM2M path: /1024//75
   *
   * @tapVersion(">=1.107")
   * @return
   */
  getDisabledServices(): Promise<TapResponse<ServiceCode[]>> {
    return this.serviceCallRunner.execute(this.getDisabledServicesCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//75
   *
   * @tapVersion(">=1.107")
   * @return call options
   */
  getDisabledServicesCall(): ServiceCallType {
    const callOptions = { ...this.resources.getDisabledServices };

    return callOptions;
  }

  /**
   * Enable/disable execution of services
   *
   * LWM2M path: /1024//75
   *
   * @tapVersion(">=1.107")
   * @param serviceCodes input
   * @return
   */
  postDisabledServices(
    /*
     *
     */
    serviceCodes: ServiceCode[],
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.postDisabledServicesCall(serviceCodes),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//75
   *
   * @tapVersion(">=1.107")
   * @param serviceCodes input
   * @return call options
   */
  postDisabledServicesCall(
    /*
     *
     */
    serviceCodes: ServiceCode[],
  ): ServiceCallType {
    const callOptions = { ...this.resources.postDisabledServices };

    callOptions.body = serviceCodes;

    return callOptions;
  }

  /**
   * Get network options
   *
   * LWM2M path: /1024//127
   *
   * @tapVersion(">=2.13")
   * @return
   */
  getNetworkOptions(): Promise<TapResponse<NetworkOptions>> {
    return this.serviceCallRunner.execute(this.getNetworkOptionsCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//127
   *
   * @tapVersion(">=2.13")
   * @return call options
   */
  getNetworkOptionsCall(): ServiceCallType {
    const callOptions = { ...this.resources.getNetworkOptions };

    return callOptions;
  }

  /**
   * Write network options
   *
   * LWM2M path: /1024//127
   *
   * @tapVersion(">=2.13")
   * @param mode input
   * @return
   */
  putNetworkOptions(
    /*
     *
     */
    mode: NetworkOptions,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putNetworkOptionsCall(mode));
  }

  /**
   *
   *
   * LWM2M path: /1024//127
   *
   * @tapVersion(">=2.13")
   * @param mode input
   * @return call options
   */
  putNetworkOptionsCall(
    /*
     *
     */
    mode: NetworkOptions,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putNetworkOptions };

    callOptions.body = mode;

    return callOptions;
  }

  /**
   * Get Radio Mix enable status
   *
   * LWM2M path: /1024//132
   *
   * @tapVersion(">=2.13")
   * @return
   */
  getRadioMixEnabled(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getRadioMixEnabledCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//132
   *
   * @tapVersion(">=2.13")
   * @return call options
   */
  getRadioMixEnabledCall(): ServiceCallType {
    const callOptions = { ...this.resources.getRadioMixEnabled };

    return callOptions;
  }

  /**
   * Write LTE enable status
   *
   * LWM2M path: /1024//132
   *
   * @tapVersion(">=2.13")
   * @param mode input
   * @return
   */
  putRadioMixEnabled(
    /*
     *
     */
    mode: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putRadioMixEnabledCall(mode));
  }

  /**
   *
   *
   * LWM2M path: /1024//132
   *
   * @tapVersion(">=2.13")
   * @param mode input
   * @return call options
   */
  putRadioMixEnabledCall(
    /*
     *
     */
    mode: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putRadioMixEnabled };

    callOptions.body = mode;

    return callOptions;
  }

  /**
   * Get NFC connection priority over other protocols
   *
   * LWM2M path: /1024//24
   *
   * @tapVersion(">=1.85")
   * @return
   */
  getNfcConnectionPriority(): Promise<TapResponse<NfcConnectionPriority>> {
    return this.serviceCallRunner.execute(this.getNfcConnectionPriorityCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//24
   *
   * @tapVersion(">=1.85")
   * @return call options
   */
  getNfcConnectionPriorityCall(): ServiceCallType {
    const callOptions = { ...this.resources.getNfcConnectionPriority };

    return callOptions;
  }

  /**
   * Set NFC connection priority over other protocols (until reboot)
   *
   * LWM2M path: /1024//24
   *
   * @tapVersion(">=1.85")
   * @param key input
   * @return
   */
  postNfcConnectionPriority(
    /*
     *
     */
    key: NfcConnectionPriority,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.postNfcConnectionPriorityCall(key),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//24
   *
   * @tapVersion(">=1.85")
   * @param key input
   * @return call options
   */
  postNfcConnectionPriorityCall(
    /*
     *
     */
    key: NfcConnectionPriority,
  ): ServiceCallType {
    const callOptions = { ...this.resources.postNfcConnectionPriority };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Write in configuration NFC connection priority over other protocols
   *
   * LWM2M path: /1024//24
   *
   * @tapVersion(">=1.85")
   * @param key input
   * @return
   */
  putNfcConnectionPriority(
    /*
     *
     */
    key: NfcConnectionPriority,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putNfcConnectionPriorityCall(key),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//24
   *
   * @tapVersion(">=1.85")
   * @param key input
   * @return call options
   */
  putNfcConnectionPriorityCall(
    /*
     *
     */
    key: NfcConnectionPriority,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putNfcConnectionPriority };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Get NFC autolog profile id
   *
   * LWM2M path: /1024//43
   *
   * @tapVersion(">=1.55")
   * @return
   */
  getNfcAutologProfileId(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getNfcAutologProfileIdCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//43
   *
   * @tapVersion(">=1.55")
   * @return call options
   */
  getNfcAutologProfileIdCall(): ServiceCallType {
    const callOptions = { ...this.resources.getNfcAutologProfileId };

    return callOptions;
  }

  /**
   * Write NFC autolog profile id
   *
   * LWM2M path: /1024//43
   *
   * @tapVersion(">=1.55")
   * @param value input
   * @return
   */
  putNfcAutologProfileId(
    /*
     *
     */
    value: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putNfcAutologProfileIdCall(value),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//43
   *
   * @tapVersion(">=1.55")
   * @param value input
   * @return call options
   */
  putNfcAutologProfileIdCall(
    /*
     *
     */
    value: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putNfcAutologProfileId };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Get host inactivity period
   *
   * LWM2M path: /1024//34
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getHostInactivityPeriod(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getHostInactivityPeriodCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//34
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getHostInactivityPeriodCall(): ServiceCallType {
    const callOptions = { ...this.resources.getHostInactivityPeriod };

    return callOptions;
  }

  /**
   * Write host inactivity timeout
   *
   * LWM2M path: /1024//34
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putHostInactivityPeriod(
    /*
     *
     */
    key: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putHostInactivityPeriodCall(key),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//34
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putHostInactivityPeriodCall(
    /*
     *
     */
    key: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putHostInactivityPeriod };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Get application data
   *
   * LWM2M path: /1024//36
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getApplicationData(): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(this.getApplicationDataCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//36
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getApplicationDataCall(): ServiceCallType {
    const callOptions = { ...this.resources.getApplicationData };

    return callOptions;
  }

  /**
   * Set application data
   *
   * LWM2M path: /1024//36
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return
   */
  putApplicationData(
    /*
     *
     */
    value: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putApplicationDataCall(value));
  }

  /**
   *
   *
   * LWM2M path: /1024//36
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return call options
   */
  putApplicationDataCall(
    /*
     *
     */
    value: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putApplicationData };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Change application data
   *
   * LWM2M path: /1024//36
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return
   */
  postApplicationData(
    /*
     *
     */
    value: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.postApplicationDataCall(value));
  }

  /**
   *
   *
   * LWM2M path: /1024//36
   *
   * @tapVersion(">=1.0")
   * @param value input
   * @return call options
   */
  postApplicationDataCall(
    /*
     *
     */
    value: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.postApplicationData };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Get the Tap product key
   *
   * LWM2M path: /1024//60
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getProductKey(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getProductKeyCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//60
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getProductKeyCall(): ServiceCallType {
    const callOptions = { ...this.resources.getProductKey };

    return callOptions;
  }

  /**
   * Get max frame size for current host protocol.
   *
   * LWM2M path: /1024//88
   *
   * @tapVersion(">=1.88")
   * @return
   */
  getCurrentHostProtocolMaxFrameSize(): Promise<
    TapResponse<ProtocolMaxFrameSize>
  > {
    return this.serviceCallRunner.execute(
      this.getCurrentHostProtocolMaxFrameSizeCall(),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//88
   *
   * @tapVersion(">=1.88")
   * @return call options
   */
  getCurrentHostProtocolMaxFrameSizeCall(): ServiceCallType {
    const callOptions = {
      ...this.resources.getCurrentHostProtocolMaxFrameSize,
    };

    return callOptions;
  }

  /**
   * Execute multiple commands
   *
   * LWM2M path: /1024//89
   *
   * @tapVersion(">=1.13")
   * @param data input
   * @return
   */
  executeMultiRequestFrame(
    /*
     *
     */
    data: MultiRequestFrame,
  ): Promise<TapResponse<MultiResponseFrame>> {
    return this.serviceCallRunner.execute(
      this.executeMultiRequestFrameCall(data),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//89
   *
   * @tapVersion(">=1.13")
   * @param data input
   * @return call options
   */
  executeMultiRequestFrameCall(
    /*
     *
     */
    data: MultiRequestFrame,
  ): ServiceCallType {
    const callOptions = { ...this.resources.executeMultiRequestFrame };

    callOptions.body = data;

    return callOptions;
  }

  /**
   * Set SSL Certificate
   *
   * LWM2M path: /1024//37
   *
   * @tapVersion(">=1.86")
   * @param value input
   * @return
   */
  putCertificatePublicKey(
    /*
     * Up to 16kB
     */
    value: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putCertificatePublicKeyCall(value),
    );
  }

  putCertificatePublicKeyAppendCalls(
    /*
     * Up to 16kB
     */
    value: Uint8Array,
    chunkSize?: number,
  ) {
    return this.serviceCallRunner.createAppendCalls(
      this.putCertificatePublicKeyCall(value),
      chunkSize,
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//37
   *
   * @tapVersion(">=1.86")
   * @param value input
   * @return call options
   */
  putCertificatePublicKeyCall(
    /*
     * Up to 16kB
     */
    value: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putCertificatePublicKey };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Set SSL private key data
   *
   * LWM2M path: /1024//38
   *
   * @tapVersion(">=1.86")
   * @param value input
   * @return
   */
  putCertificatePrivateKey(
    /*
     * Up to 16kB
     */
    value: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putCertificatePrivateKeyCall(value),
    );
  }

  putCertificatePrivateKeyAppendCalls(
    /*
     * Up to 16kB
     */
    value: Uint8Array,
    chunkSize?: number,
  ) {
    return this.serviceCallRunner.createAppendCalls(
      this.putCertificatePrivateKeyCall(value),
      chunkSize,
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//38
   *
   * @tapVersion(">=1.86")
   * @param value input
   * @return call options
   */
  putCertificatePrivateKeyCall(
    /*
     * Up to 16kB
     */
    value: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putCertificatePrivateKey };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Set Public key certificate
   *
   * LWM2M path: /1024//39
   *
   * @tapVersion(">=1.86")
   * @param value input
   * @return
   */
  putCertificateRootKey(
    /*
     * Up to 16kB
     */
    value: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putCertificateRootKeyCall(value),
    );
  }

  putCertificateRootKeyAppendCalls(
    /*
     * Up to 16kB
     */
    value: Uint8Array,
    chunkSize?: number,
  ) {
    return this.serviceCallRunner.createAppendCalls(
      this.putCertificateRootKeyCall(value),
      chunkSize,
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//39
   *
   * @tapVersion(">=1.86")
   * @param value input
   * @return call options
   */
  putCertificateRootKeyCall(
    /*
     * Up to 16kB
     */
    value: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putCertificateRootKey };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Get product code
   *
   * LWM2M path: /1024//84
   *
   * @tapVersion(">=1.113")
   * @return
   */
  getProductCode(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getProductCodeCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//84
   *
   * @tapVersion(">=1.113")
   * @return call options
   */
  getProductCodeCall(): ServiceCallType {
    const callOptions = { ...this.resources.getProductCode };

    return callOptions;
  }

  /**
   * Put product code
   *
   * LWM2M path: /1024//84
   *
   * @tapVersion(">=1.113")
   * @param topic input
   * @return
   */
  putProductCode(
    /*
     *
     */
    topic: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putProductCodeCall(topic));
  }

  /**
   *
   *
   * LWM2M path: /1024//84
   *
   * @tapVersion(">=1.113")
   * @param topic input
   * @return call options
   */
  putProductCodeCall(
    /*
     *
     */
    topic: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putProductCode };

    callOptions.body = topic;

    return callOptions;
  }

  /**
   * Get bundle id for the special feature
   *
   * LWM2M path: /1024//{featureId}
   *
   * @tapVersion(">=1.23")
   * @param featureId input
   * @return
   */
  getSpecialFeatureProfile(
    /*
     *
     */
    featureId: number,
  ): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(
      this.getSpecialFeatureProfileCall(featureId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//{featureId}
   *
   * @tapVersion(">=1.23")
   * @param featureId input
   * @return call options
   */
  getSpecialFeatureProfileCall(
    /*
     *
     */
    featureId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getSpecialFeatureProfile };

    callOptions.pathParameters = {
      featureId: featureId,
    };

    return callOptions;
  }

  /**
   * Set bundle id that own the special feature (not available anymore)
   *
   * LWM2M path: /1024//{featureId}
   *
   * @tapVersion(">=1.23")
   * @param featureId input
   * @param value input
   * @return
   */
  setSpecialFeatureProfile(
    /*
     *
     */
    featureId: number,

    /*
     * Profile id
     */
    value: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.setSpecialFeatureProfileCall(featureId, value),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//{featureId}
   *
   * @tapVersion(">=1.23")
   * @param featureId input
   * @param value input
   * @return call options
   */
  setSpecialFeatureProfileCall(
    /*
     *
     */
    featureId: number,

    /*
     * Profile id
     */
    value: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.setSpecialFeatureProfile };

    callOptions.body = value;

    callOptions.pathParameters = {
      featureId: featureId,
    };

    return callOptions;
  }

  /**
   * Write bundle id for the special feature
   *
   * LWM2M path: /1024//{featureId}
   *
   * @tapVersion(">=1.23")
   * @param featureId input
   * @param value input
   * @return
   */
  putSpecialFeatureProfile(
    /*
     *
     */
    featureId: number,

    /*
     * Profile id
     */
    value: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putSpecialFeatureProfileCall(featureId, value),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//{featureId}
   *
   * @tapVersion(">=1.23")
   * @param featureId input
   * @param value input
   * @return call options
   */
  putSpecialFeatureProfileCall(
    /*
     *
     */
    featureId: number,

    /*
     * Profile id
     */
    value: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putSpecialFeatureProfile };

    callOptions.body = value;

    callOptions.pathParameters = {
      featureId: featureId,
    };

    return callOptions;
  }
}
